<style>
.layout.row {
  margin-bottom: 20px !important;
}

.is-manager-row {
  background: #c5ceff !important;
}
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align: right;">
          <h3 style="float: left;">Ставки</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down"></v-text-field>
              <v-btn flat style="background-color: none;">
                <v-switch v-model="filterTestStaff" label="Тестовые ставки" color="error"></v-switch>
              </v-btn>
              <v-btn v-if="!showDetailedSearch" @click="showDetailedSearch = true" icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-btn v-if="showDetailedSearch" @click="detailedSearchClear" icon>
                <v-icon>clear</v-icon>
              </v-btn>
            </v-toolbar>

            <v-slide-y-transition>
              <v-layout v-if="showDetailedSearch" style="padding-left: 25px; padding-right: 25px;" card color="white">
                <v-flex v-for="sd in detailedSearch" :key="sd.searchKey">
                  <v-text-field flat prepend-icon="search" :placeholder="sd.placeholder" v-model="sd.text" hide-details
                    class="hidden-sm-and-down"></v-text-field>
                </v-flex>
              </v-layout>
            </v-slide-y-transition>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="complex.headers" :search="search" :items="staffData"
                :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1" item-key="name"
                no-results-text="Нет результатов" rows-per-page-text="На странице" v-model="complex.selected">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.pgName }}</td>
                    <td>{{!!positionList.find(p => p.value === props.item.positionId) ? positionList.find(p => p.value
                      === props.item.positionId).text : '-'}}</td>
                    <td>
                      <v-chip v-for="role in roleList.filter(r => props.item.roleKeyList.includes(r.value))"
                        v-bind:data="role" v-bind:key="role.value" :class="getRoleColor(role.value)" text-color="white">
                        <v-avatar>
                          <v-icon>account_circle</v-icon>
                        </v-avatar>
                        {{ role.text }}
                      </v-chip>
                    </td>
                    <td>{{!!staffData.find(s => s.id === props.item.managerId) ? staffData.find(s => s.id ===
                      props.item.managerId).pgName : '-'}}</td>
                    <td>{{ props.item.targetFrequencyIncrement }}</td>
                    <td>
                      <v-icon color="teal" v-if="props.item.isActive == 1">check</v-icon>
                      <v-icon color="error" v-if="props.item.isActive == 0">close</v-icon>
                    </td>
                    <td>
                      <v-btn depressed outline icon fab dark color="pink" small @click="logsOpen(props.item)">
                        <v-icon>format_align_left</v-icon>
                      </v-btn>

                      <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>

                      <!-- <v-btn
                        depressed
                        outline
                        icon
                        fab
                        dark
                        color="pink"
                        small
                        @click="removeItemConfirm(props.item)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>-->
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- Окно списка логов -->
              <div slot="widget-content">
                <v-dialog v-model="popupLogs.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Список лог файлов</span>
                    </v-card-title>
                    <v-flex xs6>
                      <v-subheader>{{ popupLogs.pgNameStaff }}</v-subheader>
                    </v-flex>
                    <v-toolbar card color="white">
                      <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="searchLog" hide-details
                        class="hidden-sm-and-down"></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-layout row>
                      <v-data-table :headers="complexLog.headers" :search="searchLog" :items="LogsServerData"
                        :rows-per-page-items="[10, 25, 50, 100]" hide-actions v-bind:pagination.sync="pagination"
                        class="elevation-1" item-key="fileName" no-results-text="Нет результатов"
                        rows-per-page-text="На странице" v-model="complex.selected"
                        style="overflow-y: scroll;  height: 500px; width: 100%;">
                        <template slot="items" slot-scope="props">
                          <tr>
                            <td>{{ props.item.fileDate }}</td>
                            <v-btn @click="openJsonLog(props.item)" color="info">
                              Детально
                              <v-icon right dark>list</v-icon>
                            </v-btn>
                            <v-btn @click="openUrl(props.item.fileUrl)" color="success">
                              Файл
                              <v-icon right dark>insert_drive_file</v-icon>
                            </v-btn>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-layout>
                    <v-card-actions>
                      <v-btn flat @click="logsClose()">Закрыть</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
              <!-- Открытие таблицы с детальным логом  -->
              <div slot="widget-content">
                <v-dialog v-model="popupJsonLogs.isOpen" persistent max-width="900px">
                  <v-card>
                    <v-card-title>
                      <v-flex sm12 style="text-align:right">
                        <span style="float:left" class="headline">Детальный просмотр лога</span>
                        <v-btn color="blue" dark small fab @click="refreshJsonLog(popupJsonLogs.jsonFileUrl)">
                          <v-icon>refresh</v-icon>
                        </v-btn>
                        <v-btn dark small fab @click="openUrl(popupJsonLogs.fileUrl)" color="success">
                          <v-icon>insert_drive_file</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-card-title>
                    <v-flex xs6>
                      <v-subheader>{{ popupLogs.pgNameStaff }} ({{ popupJsonLogs.dateLog }})</v-subheader>
                    </v-flex>
                    <v-toolbar card color="white">
                      <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="searchJsonLog"
                        hide-details class="hidden-sm-and-down" style="width: 70%;"></v-text-field>
                      <v-layout row wrap style="padding-top: 50px;">
                        <v-switch v-model="popupJsonLogs.filterError" label="Ошибки" color="error"></v-switch>
                        <v-switch v-model="popupJsonLogs.filterAnswer" label="Ответы" color="info"
                          hide-details></v-switch>
                      </v-layout>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-layout row>
                      <v-data-table :headers="complexJsonLog.headers" :search="searchJsonLog" :items="filteredLogs"
                        item-key="idRow" hide-actions class="elevation-1" no-results-text="Нет результатов"
                        v-model="complex.selected" style="overflow-y: scroll;  height: 500px; width: 100%;">
                        <template slot="items" slot-scope="props">
                          <tr @click="props.expanded = !props.expanded && props.item.isAnswer">
                            <td :style="{ backgroundColor: (props.item.isStartVisit ? '#C5E1A5' : 'transparent') }">{{
                              props.item.timeRow }}</td>
                            <td v-if="!props.item.isAnswer && !props.item.isStartVisit">{{ props.item.messageRow }}
                            </td>
                            <td v-if="props.item.isStartVisit" :style="{ backgroundColor: '#C5E1A5' }">
                              Визит в клинику
                              {{clinicList.filter(item => item.value === props.item.shopId).length > 0 ?
                                '"' + clinicList.filter(item => item.value === props.item.shopId)[0].text + '"' :
                                ''}}({{ props.item.shopId }})
                              Стоматолог
                              {{employeeList.filter(item => item.value === props.item.employeeId).length > 0 ?
                                '"' + employeeList.filter(item => item.value === props.item.employeeId)[0].text + '"' : ''
                              }}({{ props.item.employeeId }})
                            </td>
                            <td v-if="props.item.isAnswer">Ответы в анкетах</td>
                            <td :style="{ backgroundColor: (props.item.isStartVisit ? '#C5E1A5' : 'transparent') }">
                              <v-icon color="teal" v-if="props.item.isAnswer">help</v-icon>
                              <v-icon color="error" v-if="props.item.isErrorRow">error</v-icon>
                            </td>
                          </tr>
                        </template>
                        <template slot="expand" slot-scope="props">
                          <v-card color="blue-grey" dark tile flat>
                            <div v-for="item in props.item.answerRow" v-bind:key="item.rowStr">
                              <v-card-text v-if="item.textValue != ''"
                                style="padding: unset!important; padding-left: 20px; padding-top: 5px;">
                                {{questionList.filter(element => element.value === item.questId).length > 0 ?
                                  questionList.filter(element => element.value === item.questId)[0].text + ":" : ''}}
                                {{ item.textValue + " - " }} {{ item.numberValue }}
                              </v-card-text>
                            </div>
                          </v-card>
                        </template>
                      </v-data-table>
                    </v-layout>
                    <v-card-actions>
                      <v-btn flat @click="logsJsonClose()">Закрыть</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
              <!-- Редактирование и добавление новой ставки -->
              <div slot="widget-content">
                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">Редактирование</span>
                      <span class="headline" v-if="editedIndex === -1">Добавление</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <span>{{ modalData.id }}</span>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>PG код</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <span v-if="readonlyFields">{{ modalData.pgName }}</span>
                            <v-text-field v-if="!readonlyFields" label="PG код" v-model="modalData.pgName"
                              :rules="rules.pgName" required></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Должность</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Должность" :items="positionList" v-model="modalData.positionId"
                              return-object @change="changePosition($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Роль</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-select v-model.lazy="modalData.roleKeyList" :items="roleList" attach chips
                              deletable-chips label="Роль" multiple></v-select>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Менеджер</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete label="Менеджер" :items="managerList" v-model="modalData.managerId"
                              return-object @change="changeManager($event)"></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Города</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-autocomplete v-model.lazy="modalData.cityIdList" :items="cityList" attach chips
                              deletable-chips label="Города" multiple />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Поправка по частоте посещений</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Поправка по частоте посещений"
                              v-model="modalData.targetFrequencyIncrement"
                              :rules="rules.targetFrequencyIncrement"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Промокод</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Промокод" v-model="modalData.promoCode"></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Активен</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isActive"></v-switch>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Тестовая ставка</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isTest"></v-switch>
                          </v-flex>
                        </v-layout>

                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить ставку?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { uuid } from "vue-uuid";

export default {
  components: {},
  data() {
    return {
      pagination: { sortBy: "fileDate", descending: true, rowsPerPage: -1 }, // Сортировка по умолчанию для таблицы
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      showPsw: false,
      readonlyFields: true,
      filterTestStaff: false,
      rules: {
        required: [v => !!v || "Обязательное поле"],
        pgName: [
          v => !!v || "PG код не может быть пустым",
          v => this.staffData.filter(el => el.pgName === v).length === 0 || "Такой PG код уже существует"
        ],
        targetFrequencyIncrement: [
          v => /^[0-9]*$/.test(v) || "Допустимы только целочисленные значения",
        ]
      },
      search: "",
      searchLog: "",
      searchJsonLog: "",
      showDetailedSearch: false,
      detailedSearch: [
        {
          placeholder: "ID",
          searchKey: "id",
          text: ""
        },
        {
          placeholder: "PG код",
          searchKey: "pgName",
          text: ""
        }
      ],
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false
      },
      popupLogs: {
        isOpen: false,
        pgNameStaff: ""
      },
      popupJsonLogs: {
        isOpen: false,
        dateLog: "",
        jsonFileUrl: "",
        fileUrl: "",
        filterError: false,
        filterAnswer: false
      },
      complex: {
        selected: [],
        headers: [
          {
            text: "ID",
            value: "id"
          },
          {
            text: "PG код",
            value: "pgName"
          },
          {
            text: "Должность",
            value: "positionId"
          },
          {
            text: "Роль",
            value: "roleKeyList"
          },
          {
            text: "Менеджер",
            value: "managerId"
          },
          {
            text: "Поправка по частоте посещений",
            value: "targetFrequencyIncrement"
          },
          {
            text: "Активен",
            value: "isActive"
          },
          {
            text: "Действия",
            value: ""
          }
        ]
      },
      complexLog: {
        selected: [],
        headers: [
          {
            text: "Дата",
            value: "fileDate"
          },
          {
            text: "Действия",
            value: "fileUrl"
          }
        ]
      },
      complexJsonLog: {
        selected: [],
        headers: [
          {
            text: "Время",
            value: "timeRow"
          },
          {
            text: "Сообщение",
            value: "messageRow"
          },
          {
            text: "Тип",
            value: ""
          }
        ]
      }
    };
  },

  computed: {
    staffData() {
      let tmpStaffData = this.$store.getters["staff/staffData"];

      this.detailedSearch.forEach(filter => {
        if (filter.text !== "") {
          tmpStaffData = tmpStaffData.filter(tsd => String(tsd[filter.searchKey]).toLowerCase().indexOf(filter.text.toLowerCase()) !== -1);
        }
      });

      tmpStaffData = tmpStaffData.filter(tsd => tsd.isTest === this.filterTestStaff);

      return tmpStaffData;
    },

    employeeList() {
      return this.$store.getters["employees/items"].map(item => {
        return {
          text: item.lastName + " " + item.firstName + " " + item.middleName,
          value: item.id.toString()
        };
      });
    },

    LogsServerData() {
      return this.$store.getters["logServer/LogsServerData"];
    },

    jsonLogServerData() {
      return this.$store.getters["logServer/jsonLogServerData"];
    },

    filteredLogs() {
      let tempResponse = this.$store.getters["logServer/jsonLogServerData"];

      if (this.popupJsonLogs.filterError) {
        tempResponse = this.$store.getters["logServer/jsonLogServerData"].filter(lsd => lsd.isErrorRow === true);
      }

      if (this.popupJsonLogs.filterAnswer) {
        tempResponse = this.$store.getters["logServer/jsonLogServerData"].filter(lsd => lsd.isAnswer === true);
      }

      return tempResponse;
    },

    accountList() {
      return this.$store.getters["account/accountData"];
    },

    roleList() {
      return this.$store.getters["role/roleData"].map(item => {
        return { text: item.roleTitle, value: item.roleKey };
      });
    },

    questionList() {
      return this.$store.getters["pollQuests/pollQuestsData"].map(pq => {
        return {
          text: pq.name,
          value: pq.Id.toString()
        };
      });
    },

    positionList() {
      return this.$store.getters["staffPosition/staffPositionData"].map(item => {
        return { text: item.title, value: item.id };
      });
    },

    managerList() {
      let result = [];

      this.$store.getters["staff/staffData"].forEach(item => {
        if (!!item.id && !!item.pgName) {
          result.push({
            text: item.pgName,
            value: item.id
          });
        }
      });

      return result;
    },

    clinicList() {
      return this.$store.getters["clinics/items"].map(item => {
        return {
          text: item.name + ", " + item.address,
          value: item.id.toString()
        };
      });
    },

    cityList() {
      return this.$store.getters['cities/selectableItems'].map(item => {
        return { text: item.name, value: item.id.toString() };
      });
    }
  },

  mounted: function () {
    if (!this.staffData.length) this.refresh();

    if (!this.$store.getters['account/accountData'].length) {
      this.$store.dispatch('account/getAccountData');
    }

    if (!this.$store.getters['role/roleData'].length) {
      this.$store.dispatch('role/getRoleData');
    }

    if (!this.$store.getters['employees/items'].length) {
      this.$store.dispatch('employees/loadItems');
    }

    if (!this.$store.getters['pollQuests/pollQuestsData'].length) {
      this.$store.dispatch('pollQuests/getPollQuestsData');
    }

    if (!this.$store.getters['staffPosition/staffPositionData'].length) {
      this.$store.dispatch('staffPosition/getStaffPositionData');
    }

    if (!this.$store.getters['clinics/items'].length) {
      this.$store.dispatch('clinics/loadItems');
    }

    if (!this.$store.getters['cities/items'].length) {
      this.$store.dispatch('cities/loadItems');
    }
  },

  methods: {
    refresh() {
      this.$store.dispatch('staff/getStaffData');
    },

    logsOpen(item) {
      let accountByStaffExtId = this.accountList.find(acc => acc.extId === item.extId);

      this.$store.dispatch('logServer/getLogServerData', { username: accountByStaffExtId.username });

      this.popupLogs.pgNameStaff = item.pgName;
      this.popupLogs.isOpen = true;
    },

    openUrl(item) {
      window.open(item, "_blank");
    },

    logsClose() {
      this.popupLogs.isOpen = false;
    },

    openJsonLog(item) {
      this.$store.dispatch('logServer/getJsonLogServerData', { urlJsonLog: item.jsonFileUrl });

      this.popupJsonLogs.fileUrl = item.fileUrl;
      this.popupJsonLogs.jsonFileUrl = item.jsonFileUrl;
      this.popupJsonLogs.dateLog = item.fileDate;
      this.popupJsonLogs.isOpen = true;
    },

    logsJsonClose() {
      this.popupJsonLogs.isOpen = false;
    },

    refreshJsonLog(item) {
      this.$store.dispatch('logServer/getJsonLogServerData', { urlJsonLog: item });
    },

    editOpen(item) {
      // Если редактирование
      if (item !== null && typeof item !== "undefined") {
        item.cityIdList = item.cityIdList.filter(city => city != '');

        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.staffData.indexOf(item);
        this.readonlyFields = true;
        // Если добавление
      } else {
        this.modalData = {
          id: "-1",
          pgName: null,
          positionId: "",
          roleKeyList: [],
          managerId: null,
          cityIdList: [],
          targetFrequencyIncrement: "",
          promoCode: "",
          extId: uuid.v1(),
          isActive: true,
          isTest: false,
        };

        this.oldModalData = {};
        this.editedIndex = -1;
        this.readonlyFields = false;
      }

      this.popupEdit.isOpen = true;
    },

    editCancel() {
      if (this.editedIndex != -1) {
        Object.assign(this.staffData[this.editedIndex], this.oldModalData);
      }

      this.popupEdit.isOpen = false;
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('staff/saveStaffData', { index: this.editedIndex, data: this.modalData })
          .then(() => {
            this.popupEdit.isOpen = false;
          });
      }
    },

    removeItemConfirm(data) {
      this.popupRemove.isOpen = true;
      this.modalData = data;
    },

    actionRemove(item) {
      this.$store.dispatch('staff/removeStaffData', { item });
      this.popupRemove.isOpen = false;
    },

    changeManager(event) {
      if (event !== null && typeof event === "object") {
        this.modalData.managerId = event.value;
      }
    },

    changePosition(event) {
      if (event !== null && typeof event === "object") {
        this.modalData.positionId = event.value;
      }
    },

    getRoleColor(roleKey) {
      const role = this.$store.getters["role/roleData"].find(item => item.roleKey === roleKey)
      return role ? role.roleColor : '';
    },

    detailedSearchClear() {
      this.detailedSearch = this.detailedSearch.map(s => ({
        ...s,
        text: '',
      }));
      this.showDetailedSearch = false;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ui/Staffs.vue